import md5 from 'js-md5';
import Decimal from 'decimal.js';
export default {
  install(Vue) {
    //权限判断
    Vue.prototype.$isPerm = (mark = '') => {
      const marks = Vue.prototype.$permMark;
      return marks.includes(mark);
    };
    //设置权限标识
    Vue.prototype.$setPermMark = (marks = []) => {
      Vue.prototype.$permMark = marks;
    };
    //金额四舍五入
    Vue.prototype.$amountRound = (amount, precision = 2) => {
      if (isNaN(amount)) return 0;
      amount = Number(amount);
      const d = new Decimal(amount);
      return d.toDecimalPlaces(precision).toNumber();
    };
    //计算不含税价格
    Vue.prototype.$calcPrice = (tax_inc_price, tax_rate) => {
      if (isNaN(tax_inc_price) || tax_inc_price == 0) return 0;
      if (isNaN(tax_rate) || tax_rate == 0) return tax_inc_price;
      const percent = Vue.prototype.$numberDiv(tax_rate, 100);
      const rate = Vue.prototype.$numberPlus(1, percent);
      return Vue.prototype.$numberDiv(tax_inc_price, rate);
    };
    //计算不含税金额
    Vue.prototype.$calcAmount = (tax_inc_amount, tax_rate) => {
      if (isNaN(tax_inc_amount) || tax_inc_amount == 0) return 0;
      if (isNaN(tax_rate) || tax_rate == 0) return tax_inc_amount;
      const percent = Vue.prototype.$numberDiv(tax_rate, 100);
      const rate = Vue.prototype.$numberPlus(1, percent);
      return Vue.prototype.$numberDiv(tax_inc_amount, rate);
    };
    //计算税额
    Vue.prototype.$calcTaxAmount = (tax_inc_amount, amount) => {
      if (isNaN(tax_inc_amount) || tax_inc_amount == 0 || isNaN(amount) || amount == 0) return 0;
      return Vue.prototype.$numberSub(tax_inc_amount, amount);
    };
    //计算含税价格
    Vue.prototype.$calcTaxIncPrice = (price, tax_rate) => {
      if (isNaN(price) || price == 0) return 0;
      if (isNaN(tax_rate) || tax_rate == 0) return price;
      const percent = Vue.prototype.$numberDiv(tax_rate, 100);
      const rate = Vue.prototype.$numberPlus(1, percent);
      return Vue.prototype.$numberNul(price, rate);
    };
    //数字相乘
    Vue.prototype.$numberNul = (n1, n2, p = 2) => {
      if (isNaN(n1) || isNaN(n2) || n1 == 0 || n2 == 0) return 0;
      const d_n1 = new Decimal(n1);
      const d_n2 = new Decimal(n2);
      return d_n1.mul(d_n2).toDecimalPlaces(p).toNumber();
    };
    //数字相除
    Vue.prototype.$numberDiv = (n1, n2, p = 2) => {
      if (isNaN(n1) || isNaN(n2) || n1 == 0 || n2 == 0) return 0;
      const d_n1 = new Decimal(n1);
      const d_n2 = new Decimal(n2);
      return d_n1.div(d_n2).toDecimalPlaces(p).toNumber();
    };
    //数字相加
    Vue.prototype.$numberPlus = (n1, n2, p = 2) => {
      if (isNaN(n1)) n1 = 0;
      if (isNaN(n1)) n2 = 0;
      const d_n1 = new Decimal(n1);
      const d_n2 = new Decimal(n2);
      return d_n1.plus(d_n2).toDecimalPlaces(p).toNumber();
    };
    //数字相减
    Vue.prototype.$numberSub = (n1, n2, p = 2) => {
      if (isNaN(n1)) n1 = 0;
      if (isNaN(n2)) n2 = 0;
      const d_n1 = new Decimal(n1);
      const d_n2 = new Decimal(n2);
      return d_n1.sub(d_n2).toDecimalPlaces(p).toNumber();
    };
    // 获取认证数据
    Vue.prototype.$getAuth = () => {
      let auth = {
        uuid: '',
        secret_key: ''
      };
      try {
        let authJson = sessionStorage.getItem('auth');
        if (!authJson) {
          authJson = localStorage.getItem('auth');
        }
        if (!authJson) {
          return auth;
        }
        let data = JSON.parse(authJson);
        if (data && typeof data === 'object' && data.uuid) {
          return data;
        }
        return auth;
      } catch (e) {
        return auth;
      }
    };
    //生成TOKEN
    Vue.prototype.$token = () => {
      const auth = Vue.prototype.$getAuth();
      const { uuid, secret_key } = auth;
      const code = Math.random().toString(36).slice(-8);
      const timestamp = Date.now().toString();
      const signedStr = `${uuid}${secret_key}${timestamp}${code}`;
      const token = {
        uuid,
        timestamp,
        code,
        sign: md5(signedStr)
      };
      const tokenJson = JSON.stringify(token);
      return window.btoa(encodeURIComponent(tokenJson));
    };
  }
};
